/* global femcare */

/**
 * Search modal component.
 * Handles behaviour specific to the search modal overlay,
 * including trending topics animation and any future modal interactions.
 */
femcare.search.searchModal = {
    /**
     * Initializes search modal functionality.
     */
    init() {
        this.initTrendingTopics();
    },

    /**
     * Watches for the search modal to open and triggers the topics link animation.
     */
    initTrendingTopics() {
        const searchModal = document.querySelector('.modal--search');
        if (!searchModal) return;

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName === 'class' && searchModal.classList.contains('displayed')) {
                    requestAnimationFrame(() => {
                        this.animateTopicsLinks();
                    });
                }
            });
        });

        observer.observe(searchModal, { attributes: true });
    },

    /**
     * Animates trending topic links by stacking them at the list centre on open,
     * then flying each one to its final position in a random settling order.
     */
    animateTopicsLinks() {
        const list = document.querySelector('.modal--search__topics-list');
        if (!list) return;

        const items = Array.from(list.querySelectorAll('li'));
        if (!items.length) return;

        const listRect = list.getBoundingClientRect();
        const listCenterX = listRect.width / 2;
        const listCenterY = listRect.height / 2;

        // Capture each item's natural position relative to the list before modifying layout
        const naturalPositions = items.map((item) => {
            const rect = item.getBoundingClientRect();
            return {
                x: rect.left - listRect.left,
                y: rect.top - listRect.top,
                width: rect.width,
                height: rect.height,
            };
        });

        // Pin the list height and switch items to absolute so they can be repositioned freely
        list.style.position = 'relative';
        list.style.height = `${listRect.height}px`;

        items.forEach((item, i) => {
            const pos = naturalPositions[i];
            item.style.position = 'absolute';
            item.style.left = `${pos.x}px`;
            item.style.top = `${pos.y}px`;
            item.style.width = `${pos.width}px`;
            item.style.transition = 'none';
            // Stack all items at the centre of the list
            item.style.transform = `translate(${listCenterX - pos.x - pos.width / 2}px, ${listCenterY - pos.y - pos.height / 2}px)`;
        });

        // Build a random settling order via Fisher-Yates shuffle
        const shuffledIndices = items.map((_, i) => i);
        for (let i = shuffledIndices.length - 1; i > 0; i--) {
            const j = Math.floor((crypto.getRandomValues(new Uint32Array(1))[0] / 0x100000000) * (i + 1));
            [shuffledIndices[i], shuffledIndices[j]] = [shuffledIndices[j], shuffledIndices[i]];
        }

        // Force a reflow so the browser commits the stacked state before transitions start
        list.getBoundingClientRect();

        const staggerDelay = 80;        // ms between each item settling
        const transitionDuration = 350; // ms per individual item transition

        shuffledIndices.forEach((itemIndex, settleOrder) => {
            setTimeout(() => {
                items[itemIndex].style.transition = `transform ${transitionDuration}ms cubic-bezier(0.34, 1.56, 0.64, 1)`;
                items[itemIndex].style.transform = 'translate(0, 0)';
            }, settleOrder * staggerDelay);
        });

        // Clean up all inline styles after the full animation completes
        const totalDuration = (shuffledIndices.length - 1) * staggerDelay + transitionDuration;
        setTimeout(() => {
            list.style.position = '';
            list.style.height = '';
            items.forEach((item) => {
                item.style.position = '';
                item.style.left = '';
                item.style.top = '';
                item.style.width = '';
                item.style.transform = '';
                item.style.transition = '';
            });
        }, totalDuration + 50);
    },
};
